/**
 * vue prop
 *
 * @author Shigq
 * @date 2021/4/16 15:19
 */
var { ui } = require('@libs/dep-private')

module.exports = ui.vab
